import { FC, useCallback } from 'react';
import { useFragment, useMutation } from 'react-relay';
import { Formik } from 'formik';
import graphql from 'babel-plugin-relay/macro';

import Stack from '@mui/material/Stack';
import Form from 'components/Form';
import AccordionController from 'components/AccordionController';
import Section from 'components/Section';
import LegacyEditor from 'components/LegacyEditor';
import TextField from 'components/TextField';

import { useErrorHandler } from 'lib';
import { CountryEditMain_country$key } from '__generated__/CountryEditMain_country.graphql';

type FormValues = {
  name: string;
  description: string;
};

type Props = {
  country: CountryEditMain_country$key;
};

const CountryEditMain: FC<Props> = props => {
  const errorHandler = useErrorHandler();

  const { id, name, description } = useFragment(
    graphql`
      fragment CountryEditMain_country on Country {
        id
        name
        description
      }
    `,
    props.country
  );

  const [update, updating] = useMutation(graphql`
    mutation CountryEditMainMutation(
      $id: ID!
      $input: UpdateCountryInput!
      $first: Int!
      $after: String
      $search: String
    ) {
      updateCountry(id: $id, input: $input) {
        ...CountryEditTabs_country
        ...CountrySidebar_country
      }
    }
  `);

  const initial = {
    name,
    description: description ?? '',
  };

  const handleSubmit = useCallback(
    (input: FormValues) => {
      update({
        variables: { id, input },

        ...errorHandler({
          successMessage: 'Išsaugota',
        }),
      });
    },
    [errorHandler, id, update]
  );

  return (
    <Formik<FormValues> initialValues={initial} onSubmit={handleSubmit}>
      <Form loading={updating}>
        <AccordionController id="countryMain">
          <Section title="Apie" id="general">
            <Stack spacing={4}>
              <TextField name="name" label="Pavadinimas" />
              <LegacyEditor name="description" label="Aprašymas" />
            </Stack>
          </Section>
        </AccordionController>
      </Form>
    </Formik>
  );
};

export default CountryEditMain;
